import { ContentType } from 'enums/common';

export const ChainFilters = {
  '3': 'K-Market',
  '4': 'K-Supermarket',
  '5': 'K-Citymarket',
  '51': 'K-Rauta',
  '182': 'Onninen',
};

export const onninenChainIds = ['182'];
export const kRautaChainIds = ['51'];
export const kRuokaChainIds = ['3', '4', '5'];

export const ChainAbbreviations = {
  3: 'KM',
  4: 'KSM',
  5: 'KCM',
  51: 'KR',
  182: 'OE',
};

export const pushNotificationLimit = 'pushNotificationLimit';
export const siteDisabled = 'siteDisabled';
export const siteDisabledText = 'siteDisabledText';

export const ContentTypeNames = {
  [ContentType.News]: 'News Article',
  [ContentType.Help]: 'Help Text',
  [ContentType.UI]: 'UI Text',
};

// discountMethod 12(5%),13(7%),14(10%), 15(15%) and 16(20%)
export const ACBasketOfferPercentages = {
  '5%': {
    discountPercentage: 5,
    discountMethod: '12',
  },
  '7%': {
    discountPercentage: 7,
    discountMethod: '13',
  },
  '10%': {
    discountPercentage: 10,
    discountMethod: '14',
  },
  '15%': {
    discountPercentage: 15,
    discountMethod: '15',
  },
  '20%': {
    discountPercentage: 20,
    discountMethod: '16',
  },
};

export const UNSUPPORTED_DIMENSION_OPTIONS = [
  {
    dimensionName: 'segmentti_tarkentava',
    options: ['customerProgramFading', 'customerProgramActive', 'customerProgramPotentials'],
  },
  {
    dimensionName: 'reach',
    options: ['webstoreDelivery'],
  },
  {
    dimensionName: 'misc',
    options: ['noKGroupBest', 'singlePurchaseWebstore', 'opiskelijat', 'activeWebstore', 'potentialWebstore'],
  },
];
//All stores enabled
export const TOS_ENABLED_STORE_IDS = '*';

type ServiceTitle = {
  title: string;
  description?: string;
  url?: string;
};

export const B2C_SERVICE_TITLES: Record<string, ServiceTitle> = {
  installation: {
    title: 'Asennuspalvelu',
    description: 'Keskity nauttimaan uudesta ostoksestasi ja anna meidän asentaa se puolestasi.',
    url: 'https://www.k-rauta.fi/palvelut/asennuspalvelu',
  },
  online: {
    title: 'Verkkokaupan noutopiste',
    description: 'Teitkö tilauksen K-Raudan verkkokaupasta. Tule noutamaan tilauksesi myymälästä.',
  },
  picking: {
    title: 'Keräyspalvelu',
    description: 'Tee tilaus ennakkoon ja keräämme tuotteet valmiiksi noudettavaksi.',
    url: 'https://www.k-rauta.fi/palvelut/ennakkokerays',
  },
  house: {
    title: 'Talomyyjä',
    description:
      'Me tarjoamme sinulle talo- ja mökkivalikoiman, joista löytyy jokaiselle se oma koti. Talomerkkimme ovat muuttovalmis Ainoakoti ja Suomen vaihteleviin oloihin suunnitellut Kimara-hirsitalot, -huvilat, -mökit sekä -piharakennukset.',
    url: 'https://www.k-rauta.fi/talon-rakentaminen/talomyyjat',
  },
  assembly: {
    title: 'Kokoamispalvelu',
    description: 'Me kokoamme ostamasi tuotteet sinulle valmiiksi - sinä säästät aikaa ja hermoja.',
    url: 'https://www.k-rauta.fi/palvelut/kokoamispalvelu',
  },
  purchaseHistory: {
    title: 'Ostohistoria',
  },
  cafe: {
    title: 'Kahvio',
    description: 'Yllättikö nälkä kesken ostosten? Ei hätää meiltä löydät herkut joka nälkään.',
  },
  transport: {
    title: 'Kuljetuspalvelu',
    description: 'Hoidamme kuljetuksenkin. Toimitamme halutessasi ostoksesi puolestasi perille.',
    url: 'https://www.k-rauta.fi/palvelut/kuljetuspalvelu',
  },
  trailer: {
    title: 'Peräkärryn vuokraus',
    description: 'Vuokraa peräkärry ostosten kuljetukseen.',
    url: 'https://www.k-rauta.fi/palvelut/perakarryn-vuokraus',
  },
  renovationWasteRecycling: {
    title: 'Remonttijätteen kierrätys',
  },
  renovatorAccountCustomer: {
    title: 'Remontoijan tiliasiakkuus',
  },
  financial: {
    title: 'Remppatili',
    description:
      'Rakentaja ja remontoija, toteuta kerralla unelmasi vaivattomalla ja joustavalla K-Raudan Remppatilillä! Se on edullinen rahoitusratkaisu isompiin yksittäisiin hankintoihin tai remontointiprojekteihin.',
    url: 'https://www.k-rauta.fi/palvelut/remppatili',
  },
  planning: {
    title: 'Suunnittelupalvelu',
    description: 'Varaa ilmainen palveluaika asiantuntijalle, joka opastaa ja neuvoo sinua eteenpäin projektissasi.',
    url: 'https://www.k-rauta.fi/palvelut/suunnittelupalvelu',
  },
  appointment: {
    title: 'Sähköinen ajanvaraus',
    description: 'Varaa ilmainen palveluaika asiantuntijalle, joka opastaa ja neuvoo sinua eteenpäin projektissasi',
    url: 'https://www.k-rauta.fi/palvelut/ajanvaraus',
  },
  residentChange: {
    title: 'Asukasmuutospalvelu',
    description:
      'Urakka tiedossa? Anna K-Raudan hoitaa asukkaiden materiaalivalintoihin liittyvä palvelu, niin sinä voit keskittyä urakkaan. Teemme yksilöllisten valintojen toteuttamisesta helppoa niin asukkaalle kuin urakoitsijalle.',
    url: 'https://www.k-rauta.fi/palvelut/asukasmuutospalvelu',
  },
  renovation: {
    title: 'Remonttimestari',
    description:
      'Remonttimestari on apunasi kylpyhuone- ja keittiöremonteissa sekä kaikissa kodin sisäpintojen remonteissa. Halutessasi hoidamme koko homman alusta loppuun – sinä saat mielenrauhan ja avaimet käteen -toteutuksella valmiin lopputuloksen.',
    url: 'https://www.k-rauta.fi/palvelut/remonttimestari',
  },
  renovationService: {
    title: 'Remonttipalvelu',
  },
  cutting: {
    title: 'Sahauspalvelut',
    description:
      'Tarvitsetko puu- tai levytuotteita määrämittaan tai määrämuotoon sahattuna? Sahauspalvelumme auttaa sinua.',
  },
  cuttingSelf: {
    title: 'Sahaus itsepalveluna',
    description: '',
  },
  designer: {
    title: 'Suunnittelijapalvelu',
    description: 'Varaa ilmainen palveluaika asiantuntijalle, joka opastaa ja neuvoo sinua eteenpäin projektissasi.',
    url: 'https://www.k-rauta.fi/palvelut/suunnittelijapalvelu',
  },
  tool: {
    title: 'Työkaluvuokraus',
    description: 'Työskentele kuin ammattilainen ja vuokraa työkalut meiltä.',
  },
  tipsForMakers: {
    title: 'Vinkit tekijöistä',
  },
};

export const B2B_SERVICE_TITLES: Record<string, ServiceTitle> = {
  b2bProSeller: {
    title: 'K-RAUTA PRO -MYYJÄ',
    description:
      'K-Raudan yritysmyyjä auttaa ja palvelee sinua ja yrityksesi tarpeita. Yritysmyyjän tavoitat kaupan avaamisajasta aina vähintään klo 15.00 saakka. Jätä yhteydenottopyyntö ja PRO-myyjämme on sinuun pian yhteydessä.',
    url: 'https://asiakaspalaute.kesko.fi/palaute/krautapro-yhteydenotto',
  },
  b2bProWebshop: {
    title: 'K-RAUTA PRO -VERKKOKAUPPA',
    description:
      'Kirjaudu ammattilaisten verkkokauppaan ja tee ostoksia omin sopimushinnoin. Näet ajantasaiset saatavuus- ja tuotetiedot, teet tilaukset helposti ja saat tuotteet ennakkokeräiltynä kaupasta tai toimitettuna työmaalle. Jos sinulla ei vielä ole verkkokauppatunnusta, pyydäthän sen K-Rauta PRO -myyjältäsi.',
    url: 'https://www.k-rautapro.fi/',
  },
  b2bOfferCalculation: {
    title: 'TARJOUSLASKENTA',
    description:
      'Nopea tarjouslaskentamme auttaa oman työsi hinnoittelussa. Saat vastauksen tarjouspyyntöön arkena 24 tunnin kuluessa. Sovithan yritysmyyjän kanssa erikseen määrälaskennasta ja vaihtoehtoisten tuotteiden kartoituksesta.',
  },
  b2bPickingService: {
    title: 'KERÄYSPALVELU',
    description:
      'Tee tilaus ennakkoon ja keräämme tuotteet valmiiksi kolmessa tunnissa (ma-pe kaupan aukioloaikana). Kun teet tilauksen arkisin klo 16 mennessä, voit noutaa tuotteet seuraavana aamuna kaupan avautuessa.',
    url: 'https://www.k-rauta.fi/palvelut/ennakkokerays',
  },
  b2bTransportService: {
    title: 'KULJETUSPALVELU',
    description:
      'Hyödynnä kuljetuspalvelua ja saat varastotuotteet työmaalle viimeistään seuraavaksi päiväksi. Jos toimituksella on kiire, tiedustele kaupalta mahdollisuutta pikatoimituksiin. Keskustelethan mahdollisista lisätarpeista, kuten täsmätoimituksista kauppasi yritysmyyjän kanssa.',
    url: 'https://www.k-rauta.fi/palvelut/kuljetuspalvelu',
  },
  b2bProjectBilling: {
    title: 'LASKUTUS TYÖMAAKOHTAISESTI TAI KOONTILASKUNA',
    description: 'Selkeä laskutus helpottaa kustannusten seurantaa työmaakohtaisesti.',
  },
  b2bAssortmentAvailability: {
    title: 'YRITYSASIAKASVALIKOIMA JA SAATAVUUS',
    description:
      'Saat aina sinulle tärkeimmät tuotteet omasta sopimuskaupastasi. Mikäli sinulle tärkeitä tuotteita ei löydy varastovalikoimasta, keskustelethan asiasta K-Raudan yritysmyyjän kanssa.',
  },
  b2bExpressDelivery: {
    title: 'PIKATOIMITUS',
    description:
      'Kun työmaalla tulee tiukka paikka, tilaa meiltä pikatoimitus. Kuljetuspalvelu tuo oman kauppasi varastosta löytyvät tuotteet 4 tunnin kuluessa tilauksesta työmaalle.',
  },
  b2bScheduledDelivery: {
    title: 'TÄSMÄTOIMITUS',
    description:
      'Toimitamme valitsemasi tuotteet työmaalle koontikuormina tarkasti sovittuna ajankohtana. Täsmätoimituksena voidaan toimittaa tuotteita esimerkiksi huonekohtaisesti pakattuna tai ne voidaan kantaa perille huoneistoon saakka. Näin kaikki tarvittava on suoraan työntekijöidesi käytössä siellä, missä työkin tehdään.',
  },
  b2bCuttingService: {
    title: 'SAHAUSPALVELU',
    description:
      'Tarvitsetko puu- tai levytuotteita määrämittaan tai määrämuotoon sahattuna? Meillä on sahauspalvelu, jossa puutavara sahataan sinulle valmiiksi, kun tilaat sahauksen ennakkoon. Säästät aikaa, vaivaa ja arvokasta tilaa työmaalla.',
  },
  b2bEquipmentService: {
    title: 'VARUSTELUPALVELU',
    description: 'Tuotteet ja varusteet kohteeseen myös asennettuna ja toimitus asennusaikataulun mukaisesti.',
  },
  b2bWorkwearPrinting: {
    title: 'TYÖVAATTEIDEN PAINATUSPALVELU',
    description:
      'Kattavasta valikoimastamme löydät työvaatteet kaikkiin olosuhteisiin johtavilta työvaatevalmistajilta. Saat niihin meiltä yrityksesi logon valmiiksi painettuna.',
  },
};

export const ALL_SERVICE_TITLES: Record<string, ServiceTitle> = {
  ...B2C_SERVICE_TITLES,
  ...B2B_SERVICE_TITLES,
};
